import { FrontNaverMember } from '@shopping/naverAuth'
import { fetchNaveMember } from 'common/services/naverMember'
import { isErrorRejected } from 'common/utils/ajax/apiErrorHandler'
import HttpStatus from 'common/utils/httpStatus'
import logger from 'common/logger'
import { axios } from 'common/utils'
import { getHeaders } from 'common/utils/ajax/axios'

export interface NaverMemberState {
  isLogin: boolean
  member: FrontNaverMember
}

const initialState: NaverMemberState = {
  isLogin: false,
  member: null,
}
const FETCH = '/member/FETCH'
const FETCH_PROFILE = 'member/FETCH_PROFILE'

const DEFAULT_PROFILE_IMAGE = 'https://ssl.pstatic.net/static/common/myarea/myInfo.gif?type=s160'

export const fetchMember = (headers?: any) => async dispatch => {
  const naverMember = await fetchNaveMember(headers)
  dispatch({
    naverMember,
    type: FETCH,
  })
}

export const fetchProfile = (headers?: any, thumbnailType: string = 's160') => async dispatch => {
  try {
    const response = await axios.get('/v1/members/profile', {
      ...getHeaders(headers),
      data: {
        [isErrorRejected]: true,
      },
    })
    const { imageUrlHttps } = response && response.data
    dispatch({
      profileImageUrl: imageUrlHttps ? `${imageUrlHttps}?type=${thumbnailType}` : DEFAULT_PROFILE_IMAGE,
      type: FETCH_PROFILE,
    })
  } catch (err) {
    err.response.status !== HttpStatus.UNAUTHORIZED && logger.error(err)
    dispatch({
      profileImageUrl: DEFAULT_PROFILE_IMAGE,
      type: FETCH_PROFILE,
    })
  }
}

const memberReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        ...state,
        ...action.naverMember,
      }
    case FETCH_PROFILE:
      const newState: NaverMemberState = { ...state }
      newState.member.profileImageUrl = action.profileImageUrl
      return newState
    default:
      return state
  }
}

export default memberReducer
